import { render, staticRenderFns } from "./NotifyTTTechSwitch.vue?vue&type=template&id=2a34b23c"
import script from "./NotifyTTTechSwitch.vue?vue&type=script&lang=js"
export * from "./NotifyTTTechSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports